import { render, staticRenderFns } from "./Disclaimer.vue?vue&type=template&id=1bb95573&"
import script from "./Disclaimer.vue?vue&type=script&lang=ts&"
export * from "./Disclaimer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports